// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__pIR0L","inputDescription":"styles_inputDescription__3_Hdq"};